import React, {useState, useEffect} from 'react';
import {get as _get, toLower} from "lodash";
import {
    addErrorAlert,
    toggleGlobalLoader,
    clearAllAlerts,
    addSuccessAlert
} from "../../../store/calls/alertLoadingDispatch";
import api from '../../../store/api'
import validators from "../../../utils/forms/validators";
import {userTypeSelect} from "../../../utils/forms/preconfiguredInputs";
import BaseForm from "../../theme/forms/BaseForm";
import {updateUserDataAfterLogin} from "../../../store/calls";


const formInputs = [
    {
        type: "text",
        dataKey: "otp",
        label: "",
        placeholder: "Reset Code",
        inputClasses: "is-medium",
        validator: val => validators.isNumber.validator(val) && `${val}`.length === 6,
        errorText: "Must be a six digit number",
        "aria-label": "one-time-password"
    },
]

function OTPForm({ onSuccess, email }) {

    let [statusMessage, setStatusMessage] = useState("")
    let [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
         requestOTP({ email });
    }, [])

    const requestOTP = ({ email }) => {
        setStatusMessage("Sending you a code...")
        setIsLoading(true);

        api
            .get('auth/request-otp/', { email })
            .then((res) => {
                clearAllAlerts();
                addSuccessAlert("Email sent.")
                setStatusMessage("Please enter the code we have sent to your email.")
                return res.data;
            })
            .catch((err) => {
                clearAllAlerts();
                if (!err.response) {
                    addErrorAlert('We seem to have trouble connecting', 10 * 1000);
                } else {
                    addErrorAlert(err.response.data.error, 5 * 1000);
                }
            })
            .finally(() => {
                setIsLoading(false)
            });
    };

    const verifyOTP = ({ otp, email }) => {

        setIsLoading(true);
        return api
            .get('auth/verify-otp/', { otp, email })
            .then((res) => {
                if (res.data.valid) {
                    setStatusMessage("Success! Redirecting")
                    let token = res.data.tokens?.access;
                    updateUserDataAfterLogin(token);
                    onSuccess && onSuccess({...res.data, email, otp});
                } else {
                    addErrorAlert("That OTP was not valid")
                }
            })
            .catch((err) => {
                clearAllAlerts();
                if (!err.response) {
                    addErrorAlert('We seem to have trouble connecting', 10 * 1000);
                } else {
                    addErrorAlert(err.response.data.error, 5 * 1000);
                }
            })
            .finally(() => {
                setIsLoading(false)
            });
    };


    return (
        <div>
            <div className="has-text-weight-semibold mb-4 has-text-primary has-text-centered">{statusMessage}</div>
            <BaseForm
                aria-label="otp-form"
                inputs={formInputs}
                hideDefaultButtons
                onSubmit={(data) => {
                    const {otp} = data;
                    return verifyOTP({otp, email})
                }}
                otherButtons={
                    <>
                        <button
                            className={`button is-primary is-fullwidth is-medium ${isLoading ? 'is-loading' : ''}`}
                            type="submit"
                        >Submit</button>
                        <button
                            className="button is-ghost is-fullwidth has-text-primary-light mt-5"
                            onClick={() => requestOTP({ email })}
                        >Been a while? Resend Code.</button>
                    </>
                }
            />
        </div>
    )
}

export default OTPForm;